export default {
  ["agent_admin"]: `Agent Admin`,
  ["edit_pwd"]: `Edit Password`,
  ["logout"]: `Logout`,
  ["login"]: `Login`,
  ["register"]: `Register`,
  ["dashboard"]: `Dashboard`,
  ["registration"]: `Registration`,
  ["incomes"]: `Incomes`,
  ["record"]: `Record`,
  ["rules"]: `Rules`,
  ["account"]: `Account`,
  ["account_ph"]: `Please enter the correct account.`,
  ["password"]: `Password`,
  ["password_ph"]: `Please enter the correct password.`,
  ["remember_account"]: `Remember me`,
  ["invite_ratio"]: `INVITE PLAYERS TO GET`,
  ["invite_ratio_desc"]: `Net Settlement Profit and Loss`,
  ["product_fee_ratio"]: `PRODUCT FEE`,
  ["product_fee_ratio_desc"]: `Net Settlement Profit and Loss`,
  ["register_count"]: `Registers`,
  ["login_count"]: `Logins`,
  ["deposit_count"]: `Deposits`,
  ["first_deposit_count"]: `First Deposits`,
  ["deposit_amount"]: `Deposit`,
  ["withdraw_amount"]: `Withdrawal`,
  ["valid_bet_amount"]: `Valid Bet`,
  ["win_amount"]: `Win`,
  ["bonus_amount"]: `Bonus`,
  ["profit_amount"]: `Win/Loss`,
  ["link_manage"]: `Link Manage`,
  ["add_link"]: `Add Link`,
  ["link_reached_limit"]: `Limit Reached`,
  ["copy_success"]: `Copy Success`,
  ["submit"]: `Submit`,
  ["cancel"]: `Cancel`,
  ["download"]: `Download`,
  ["sub_domain"]: `Sub Domain`,
  ["sub_domain_ph"]: `Please enter a valid sub domain.`,
  ["tag_name"]: `Tag Name`,
  ["tag_name_ph"]: `Please enter a valid tag name.`,
  ["link_status_0"]: `Stateless`,
  ["link_status_1"]: `Initializing`,
  ["link_status_2"]: `Effective`,
  ["link_status_3"]: `Retry Available`,
  ["link_sttaus_4"]: `Unavailable`,
  ["month"]: `Month`,
  ["active_user_count"]: `Active Users`,
  ["product_fee_amount"]: `Product Fee`,
  ["dividend_ratio"]: `Rate`,
  ["dividend_amount"]: `Commission`,
  ["status"]: `Status`,
  ["dividend_bill_status_0"]: `In Progress`,
  ["dividend_bill_status_4"]: `Pending`,
  ["dividend_bill_status_9"]: `Paid`,
  ["month_phase_1"]: `First Half`,
  ["month_phase_2"]: `Second Half`,
  ["click_here"]: `Click Here`,
  ["click_here_desc"]: `to contact your account manager for USDT withdraw`,
  ["available_commission"]: `Available Commission`,
  ["time"]: `Time`,
  ["affiliate_program"]: `Affiliate Program`,
  ["active_user_desc"]: `Active Users:the number of users whose total deposit amount exceeds 300,000 during`,
  ["payout_instructions"]: `Payout Instructions`,
  ["payout_instructions_detail"]: `Each calendar month is settled twice.</br>Settlement Period 1: From the 1st to the 15th of each month (paid on the 20th).</br>Settlement Period 2: From the 16th to the last day of the month (paid on the 5th of the following month).`,
  ["rules_detail"]: `Only players registered via the agent’s referral link are eligible for dividends.</br>Every agent must share in the actual administrative costs and promotional expenses incurred by their members. These costs will be deducted from the next profitable period.</br>Only valid agents can receive dividends (at least 5 active users within 2 weeks).</br>If the negative profit for the month becomes positive, the agent will not receive dividends, and the negative profit will be carried over to the next month.</br>Any user or group engaging in abnormal arbitrage activities will have their dividends canceled. In severe cases, related accounts may be frozen or closed without prior notice, and funds will not be refunded. Such users will also be blacklisted.</br>To prevent abuse and violations of our policies and promotions, our risk control department will strictly review each agent account (including name, email, phone number, etc.). If any account is found to be engaging in arbitrage or abusing promotions in connection with other agents, we reserve the right to cancel and confiscate the balance of the agent account and any associated accounts without prior notice.</br>We reserve the right to reject or freeze the accounts of any partner agents or members.`,
  ["get_withdraw"]: `Get Dividends`,
  ["commission_history"]: `Dividend History`,
  ["link_capacity"]: `Create Link`,
  ["language"]: `Language`,
  ["old_password"]: `Old Password`,
  ["old_password_ph"]: `Please enter old password`,
  ["new_password"]: `New Password`,
  ["new_password_ph"]: `Please enter new password`,
  ["confirm_password"]: `Confirm Password`,
  ["confirm_password_ph"]: `Please confirm password`,
  ["confirm_password_not_same"]: `Password does not match`,
  ["operation_success"]: `Operation successful`,
  ["need_change_pwd_title"]: `Account needs password change`,
  ["need_change_pwd_content"]: `Account needs password change`,
  ["need_change_pwd_confirm"]: `Go to edit`,
  ["err_5001"]: `Internal error: Locking failed`,
  ["err_5002"]: `Internal error: Locking conflict`,
  ["err_5003"]: `Parameter error`,
  ["err_6001"]: `Blocked login failed`,
  ["err_6003"]: `Link limit reached, unable to add more, duplicate link creation failed`,
  ["err_6004"]: `Link creation conflict`,
  ["err_2003"]: `Invalid password`,
  ["err_2014"]: `Invalid username`,
  ["err_1303"]: `Incorrect old password`,
  ["err_1308"]: `The new password is the same as the current password.`,
  ["date_picker_today"]: `今天`,
  ["date_picker_yesterday"]: `昨天`,
  ["date_picker_7_days"]: `最近7天`,
  ["date_picker_30_days"]: `最近30天`,
  ["date_picker_this_month"]: `本月`,
  ["select_date_range"]: `请选择日期`,
  ["date_picker_ok"]: `OK`,
  ["start_date"]: `开始日期`,
  ["end_date"]: `结束日期`,
  ["date_picker_year"]: `年`,
  ["date_picker_month"]: `月`,
  ["date_picker_day"]: `日`,
}